export default {
  html: {
    id: 'cs_test_123456',
    object: 'checkout.session',
    allow_promotion_codes: null,
    amount_subtotal: 1000,
    amount_total: 1000,
    automatic_tax: {
      enabled: false,
      status: null,
    },
    billing_address_collection: 'auto',
    cancel_url: 'http://localhost:4242/cancel.html',
    client_reference_id: null,
    currency: 'usd',
    customer: null,
    customer_details: null,
    customer_email: null,
    livemode: false,
    locale: null,
    metadata: {},
    mode: 'subscription',
    payment_intent: null,
    payment_method_options: null,
    payment_method_types: ['card'],
    payment_status: 'unpaid',
    setup_intent: null,
    shipping: null,
    shipping_address_collection: null,
    submit_type: null,
    subscription: null,
    success_url:
      'http://localhost:4242/success.html?session_id={CHECKOUT_SESSION_ID}',
    total_details: {
      amount_discount: 0,
      amount_shipping: 0,
      amount_tax: 0,
    },
    url: 'https://checkout.stripe.com/pay/cs_test_123456',
  },
  react: {
    id: 'cs_test_123456',
    object: 'checkout.session',
    allow_promotion_codes: null,
    amount_subtotal: 1000,
    amount_total: 1000,
    automatic_tax: {
      enabled: false,
      status: null,
    },
    billing_address_collection: 'auto',
    cancel_url: 'http://localhost:3000/checkout?canceled=true',
    client_reference_id: null,
    currency: 'usd',
    customer: null,
    customer_details: null,
    customer_email: null,
    livemode: false,
    locale: null,
    metadata: {},
    mode: 'subscription',
    payment_intent: null,
    payment_method_options: null,
    payment_method_types: ['card'],
    payment_status: 'unpaid',
    setup_intent: null,
    shipping: null,
    shipping_address_collection: null,
    submit_type: null,
    subscription: null,
    success_url:
      'http://localhost:3000/checkout?success=true&session_id={CHECKOUT_SESSION_ID}',
    total_details: {
      amount_discount: 0,
      amount_shipping: 0,
      amount_tax: 0,
    },
    url: 'https://checkout.stripe.com/pay/cs_test_123456',
  },
};
